/**
 * @format
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import MapView from 'react-native-web-maps';

const ZTMarker = (props) => {
  return <MapView.Marker {...props} />;
};

export default ZTMarker;
